/**
 * Created by adalto on 6/3/14.
 */


Greenmile.Task = Greenmile.Task || {};
Greenmile.Task.RelatedInfo = Greenmile.Task.RelatedInfo || {};
Greenmile.Task.RelatedInfo.Order = {

    removeLinkedOrderFromList: function (el) {

        var lineItem = el.parentNode.parentNode;
        var lineItemContainer = lineItem.parentNode;
        lineItemContainer.removeChild(lineItem);

    },

    removeLinkedOrderFromData: function (el) {

        var node = el.parentNode.parentNode;
        var nodes = Monet.Session.Task.lastLinkForm.orders.nodes;
        var ids = Monet.Session.Task.lastLinkForm.orders.ids;
        var data = Monet.Session.Task.lastLinkForm.orders.data;
        var index = null;

        for (var i = 0, l = nodes.length; i < l; i++) {
            if (nodes[i].id === node.id) {
                index = i;
                break;
            }
        }

        if (index !== null) {
            nodes.splice(index, 1);
            ids.splice(index, 1);
            data.splice(index, 1);
            Monet.Session.Task.newTask.orders.splice(index, 1);
        }

    },

    createOrderIdNode: function (data) {

        var divContainer = document.createElement('div');
        var divTitle = document.createElement('div');
        var divDel = document.createElement('div');
        var divDestroy = document.createElement('div');
        var divClear = document.createElement('div');
        var inputStatus = document.createElement('input');
        var inputLinked = document.createElement('input');
        var input = document.createElement('input');
        var linkedTaskWhen = document.createElement('input');

        divContainer.id = "order_" + data.order.id;
        divContainer.className = "userListItem zebrado item_lookuplist_order_" + data.order.id;

        divTitle.className = "title_item_added";
        divTitle.appendChild(document.createTextNode(data.order.number));

        divDel.className = "del_item_added";

        divDestroy.className = "table-action-destroylink";
        divDestroy.innerHTML = "&nbsp;";
        divClear.style.clear = "both";

        divDestroy.addEventListener('click', (function (scope, data) {

            return function (e) {

                e.preventDefault();

                const confirmDeleteOrder = () => {
                    App.Views.Task.showLoadingElement(this);
                    Greenmile.Task.RelatedInfo.deleteTaskLinked(data.id, (function (e) {
                        return function () {
                            App.Views.Task.hideLoad();

                            scope.removeLinkedOrderFromList(e.target);
                            scope.removeLinkedOrderFromData(e.target, scope);
                            Greenmile.Task.RelatedInfo
                                .removeTitleContainerIfEmptyTo(
                                    Greenmile.Task.RelatedInfo.collections.ORDERS
                                );
                        };
                    }(e)));
                };

                Greenmile.Task.RelatedInfo.showAlertToConfirm(confirmDeleteOrder);

            };

        }(this, data)));

        linkedTaskWhen.type = 'hidden';
        linkedTaskWhen.id = "taskLinkeds[" + data.order.id + "].when";
        linkedTaskWhen.name = "taskLinkeds[" + data.order.id + "].when";
        linkedTaskWhen.className = "modelAttribute";
        linkedTaskWhen.value = data.when || Monet.Format.DateTime.formatToISOString(new Date());

        input.type = "hidden";
        input.name = "taskLinkeds[" + data.order.id + "].order.id";
        input.id = "taskLinkeds[" + data.order.id + "].order.id";
        input.className = "modelAttribute";
        input.value = data.order.id;

        inputStatus.type = 'hidden';
        inputStatus.name = 'taskLinkeds[' + data.order.id + '].status';
        inputStatus.id = 'taskLinkeds[' + data.order.id + '].status';
        inputStatus.className = "modelAttribute";
        inputStatus.value = '';

        inputLinked.type = 'hidden';
        inputLinked.name = 'taskLinkeds[' + data.order.id + '].id';
        inputLinked.id = 'taskLinkeds[' + data.order.id + '].id';
        inputLinked.className = "modelAttribute";
        inputLinked.value = data.id || '';

        divDel.appendChild(divDestroy);

        divContainer.appendChild(divTitle);
        divContainer.appendChild(divDel);
        divContainer.appendChild(divClear);
        divContainer.appendChild(input);
        divContainer.appendChild(inputStatus);
        divContainer.appendChild(inputLinked);
        divContainer.appendChild(linkedTaskWhen);

        Monet.Session.Task.lastLinkForm.orders.nodes.push(divContainer);
        Monet.Session.Task.lastLinkForm.orders.data.push(data);
        Monet.Session.Task.lastLinkForm.orders.ids.push(input);

    },

    createFullOrderInfo: function (data) {

        Monet.Session.Task.lastLinkForm.orders.nodes = [];
        Monet.Session.Task.lastLinkForm.orders.data = [];
        Monet.Session.Task.lastLinkForm.orders.ids = [];

        for (var i = 0, l = data.length; i < l; i++) {

            if (data[i].hasOwnProperty('order')) {
                this.createOrderIdNode(data[i]);
            }

        }

    }

};